export default {
  en: {
    auth: {
      failed: 'These credentials do not match our records.',
      throttle:
        'Too many login attempts. Please try again in {seconds} seconds.',
      authenticated: 'Already authenticated.',
    },
    pagination: {
      previous: '&laquo; Previous',
      next: 'Next &raquo;',
    },
    passwords: {
      password:
        'Passwords must be at least six characters and match the confirmation.',
      reset: 'Your password has been reset!',
      sent: 'We have e-mailed your password reset link!',
      token: 'This password reset token is invalid.',
      user: "We can't find a user with that e-mail address.",
    },
    validation: {
      accepted: 'The {attribute} must be accepted.',
      active_url: 'The {attribute} is not a valid URL.',
      after: 'The {attribute} must be a date after {date}.',
      after_or_equal:
        'The {attribute} must be a date after or equal to {date}.',
      alpha: 'The {attribute} may only contain letters.',
      alpha_dash:
        'The {attribute} may only contain letters, numbers, and dashes.',
      alpha_num: 'The {attribute} may only contain letters and numbers.',
      array: 'The {attribute} must be an array.',
      before: 'The {attribute} must be a date before {date}.',
      before_or_equal:
        'The {attribute} must be a date before or equal to {date}.',
      between: {
        numeric: 'The {attribute} must be between {min} and {max}.',
        file: 'The {attribute} must be between {min} and {max} kilobytes.',
        string: 'The {attribute} must be between {min} and {max} characters.',
        array: 'The {attribute} must have between {min} and {max} items.',
      },
      boolean: 'The {attribute} field must be true or false.',
      confirmed: 'The {attribute} confirmation does not match.',
      date: 'The {attribute} is not a valid date.',
      date_format: 'The {attribute} does not match the format {format}.',
      different: 'The {attribute} and {other} must be different.',
      digits: 'The {attribute} must be {digits} digits.',
      digits_between: 'The {attribute} must be between {min} and {max} digits.',
      dimensions: 'The {attribute} has invalid image dimensions.',
      distinct: 'The {attribute} field has a duplicate value.',
      email: 'The {attribute} must be a valid email address.',
      exists: 'The selected {attribute} is invalid.',
      file: 'The {attribute} must be a file.',
      filled: 'The {attribute} field must have a value.',
      image: 'The {attribute} must be an image.',
      in: 'The selected {attribute} is invalid.',
      in_array: 'The {attribute} field does not exist in {other}.',
      integer: 'The {attribute} must be an integer.',
      ip: 'The {attribute} must be a valid IP address.',
      ipv4: 'The {attribute} must be a valid IPv4 address.',
      ipv6: 'The {attribute} must be a valid IPv6 address.',
      json: 'The {attribute} must be a valid JSON string.',
      max: {
        numeric: 'The {attribute} may not be greater than {max}.',
        file: 'The {attribute} may not be greater than {max} kilobytes.',
        string: 'The {attribute} may not be greater than {max} characters.',
        array: 'The {attribute} may not have more than {max} items.',
      },
      mimes: 'The {attribute} must be a file of type: {values}.',
      mimetypes: 'The {attribute} must be a file of type: {values}.',
      min: {
        numeric: 'The {attribute} must be at least {min}.',
        file: 'The {attribute} must be at least {min} kilobytes.',
        string: 'The {attribute} must be at least {min} characters.',
        array: 'The {attribute} must have at least {min} items.',
      },
      not_in: 'The selected {attribute} is invalid.',
      numeric: 'The {attribute} must be a number.',
      present: 'The {attribute} field must be present.',
      regex: 'The {attribute} format is invalid.',
      required: 'The {attribute} field is required.',
      required_if: 'The {attribute} field is required when {other} is {value}.',
      required_unless:
        'The {attribute} field is required unless {other} is in {values}.',
      required_with:
        'The {attribute} field is required when {values} is present.',
      required_with_all:
        'The {attribute} field is required when {values} is present.',
      required_without:
        'The {attribute} field is required when {values} is not present.',
      required_without_all:
        'The {attribute} field is required when none of {values} are present.',
      same: 'The {attribute} and {other} must match.',
      size: {
        numeric: 'The {attribute} must be {size}.',
        file: 'The {attribute} must be {size} kilobytes.',
        string: 'The {attribute} must be {size} characters.',
        array: 'The {attribute} must contain {size} items.',
      },
      string: 'The {attribute} must be a string.',
      timezone: 'The {attribute} must be a valid zone.',
      unique: 'The {attribute} has already been taken.',
      uploaded: 'The {attribute} failed to upload.',
      url: 'The {attribute} format is invalid.',
      custom: {
        'attribute-name': {
          'rule-name': 'custom-message',
        },
      },
      attributes: [],
    },
  },
  sk: {
    auth: {
      failed: 'Nesprávne prihlasovacie meno alebo heslo',
      throttle:
        'Príliš veľa pokusov o prihlásenie. Skúste to znova za {seconds} sekúnd.',
      authenticated: 'Už ste prihlásený.',
    },
    customer: {
      name: 'Názov spoločnosti',
      formID: 'Druh právneho subj.',
      group_id: 'Skupina',
      regNumber: 'IČO',
      taxRegNumber: 'IČ DPH',
      taxNumber: 'DIČ',
      registration: 'Zapísaná v',
      registrationCode: 'Vl.č.',
      owner: 'Oprávnená osoba',
      phone: 'Kontaktný telefón',
      email: 'Email',
      active: 'Stav',
      street: 'Ulica',
      streetNumber: 'Číslo',
      streetRegNumber: 'Súp. číslo',
      postCode: 'PSČ',
      city: 'Mesto',
    },
    energetics: {
      powerNumber: 'EIC kód',
      gasNumber: 'POD kód',
      waterNumber: 'Číslo odberu',
      heatNumber: 'OM',
      ost: 'OST',
      distributionAreaID: 'Distribučné územie',
      distributionArea2ID: 'Miestna distribučná sústava',
      voltageVolumeID: 'Napäťová úroveň',
      tariffID: 'Distrib. sadzba',
      measureTypeID: 'Typ merania',
      measureTypeChangeDate: 'Dátum zmeny typu merania',
      tdoID: 'TDO',
      tddID: 'TDD',
      contractTypeID: 'Typ zmluvy',
      gaugeNumber: 'Číslo vodomeru (fakturačný / podružný)',
      reducedArea: 'Redukovaná plocha (m2)',
      heatRatioRes: '% pomer dodaného tepla - byty',
      heatRatioNonRes: '% pomer dodaného tepla - nebyty',
      totalAreaRes: 'Celková plocha byty (m2)',
      totalVolRes: 'Celkový objem byty (m3)',
      totalAreaNonRes: 'Celková plocha nebyty (m2)',
      totalVolNonRes: 'Celkový objem nebyty (m3)',
      numFloors: 'Počet podlaží',
      height: 'Svetlá výška byt/nebyt (m)',
      userID: '',
      userPassword: '',
      registrationDate: 'Dátum registrácie',
      typeID: 'Typ',
      providerID: 'Súčasný dodávateľ',
      cancellationID: 'Výpoveď podáme za Vás',
      cancellationStateID: 'Stav výpovede',
      agreementTermID: 'Zmluva uzatvorená',
      agreementEndDate: 'Zmluva končí dňa',
      consumptionDateStart: 'Dátum zač. odberu',
      evidenceTypeID: 'Spôsob evidencie',
      identityNumber: 'Číslo OP',
      contractNumber: 'Číslo zmluvy',
      disporLogin: 'DP Login',
      disporPass: 'DP Heslo',
      consumptionDateEnd: 'Dátum konca odberu',
      endpointTypeID: 'Spôsob ukončenia',
      street: 'Ulica',
      streetNumber: 'Číslo',
      streetRegNumber: 'Súp. číslo',
      postCode: 'PSČ',
      city: 'Mesto',
      locality: 'Lokalita objektu',
      localityName: 'Názov objektu',
      coordinates: 'Súradnice',
      noteTrading: '',
      noteAgreement: '',
      noteDistribution: '',
      noteTechnical: '',
      active: 'Aktívne',
    },
  },
}
